import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProductTemplates from './e-commerce-product-templates.reducer';

export const getState = createFeatureSelector<fromProductTemplates.State>(
  fromProductTemplates.eCommerceProductTemplatesFeatureKey,
);
export const getIsLoading = createSelector(getState, state => state?.isLoading);
export const getIsProcessing = createSelector(getState, state => state?.isProcessing);
export const getSearchParams = createSelector(getState, state => state?.searchParams);
export const getTemplateName = createSelector(getSearchParams, searchParams => searchParams?.templateName);
export const getSortingParams = createSelector(getSearchParams, searchParams => searchParams?.sortingParams);
export const getItems = createSelector(getState, state => state?.items || []);
export const getItemsCount = createSelector(getItems, items => items?.length);
export const getProductTemplateUsageStep = createSelector(getState, state => state?.productTemplateUsageStep);
export const getProductTemplateUsageInitiatedAt = createSelector(
  getState,
  state => state?.productTemplateUsageInitiatedAt,
);
